import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { MarkdownComponent } from 'ngx-markdown';
import { HdConditioningCardComponent } from './hd-conditioning-card.component';
import { HdBodygraphCenter } from '../bodygraph/hd-bodygraph.models';
import { HD_NOT_SELF_BY_IMPACT_ORDER } from '../bodygraph/hd-center-not-self-metadata';
import { HdGateInfoService } from '../bodygraph/hd-gate-info.service';
import { HD_LANG_RECOMPUTE_ON_LOAD, HdContentLanguageService } from '../bodygraph/hd-content-language.service';

/** Paneel-data voor het conditionering-info-paneel (momenteel geen velden nodig). */
export interface HdConditioningInfoPanelData {
  readonly _?: never;
}

/**
 * Info-paneel "Niet-Zelf Conditionering", geopend via het info-icoon naast
 * "Primaire Conditionering" in het Basis-paneel. Toont de twee tekstblokken
 * (conditioneringsimpact & poort-terminologie) en de negen conditionering-
 * blokken, gestapeld op niet-zelf impact-rang (sterkste conditionering eerst) —
 * dezelfde specifieke niet-zelf rang als op het niet-zelf deck.
 */
@Component({
  selector: 'hd-conditioning-info-panel',
  standalone: true,
  imports: [MarkdownComponent, HdConditioningCardComponent],
  templateUrl: './hd-conditioning-info-panel.component.html',
  styleUrl: './hd-conditioning-info-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HdConditioningInfoPanelComponent {
  private readonly gateInfo = inject(HdGateInfoService);
  private readonly contentLang = inject(HdContentLanguageService);

  /** De negen centers op niet-zelf impact-rang (sterkste conditionering eerst). */
  protected readonly rankedCenters: readonly HdBodygraphCenter[] = HD_NOT_SELF_BY_IMPACT_ORDER;

  private readonly lang = computed(() => this.contentLang.effectiveLang(), HD_LANG_RECOMPUTE_ON_LOAD);

  protected readonly title = computed(() => this.text('title'));
  protected readonly subtitle = computed(() => this.text('subtitle'));

  protected readonly impactMarkdownUrl = computed(
    () => `assets/docs/human-design/conditioning/${this.lang()}/impact.md`,
  );
  protected readonly terminologyMarkdownUrl = computed(
    () => `assets/docs/human-design/conditioning/${this.lang()}/terminology.md`,
  );

  constructor() {
    this.gateInfo.loadScopesForLang('nl');
    this.gateInfo.loadScopesForLang('en');
  }

  /** Conditioning-scope tekst met NL-fallback voor (nog) lege EN-velden. */
  private text(key: string): string {
    const lang = this.lang();
    const value = this.gateInfo.cheatSheetTextIn('conditioning', key, lang);
    if (value !== '' || lang === 'nl') {
      return value;
    }
    return this.gateInfo.cheatSheetTextIn('conditioning', key, 'nl');
  }
}
